module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box_double"
  }, [_c('h2', {
    staticClass: "section",
    attrs: {
      "id": "c01_sec5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#c01_sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Shopping for Antiques")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The term “French country,” when scrawled on sales tags far outside of France, evokes dreamy associations even when it’s stretching the truth. But in Provence, it’s usually a fair description of the provenance of household and farming items that are passed down through generations. They might not be fancy, but there’s beauty in their simple lines and sturdy craftsmanship. Rustic furnishings, linens, and tools make Provence a haven for antiques shoppers.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Where to Find Them")])]), _vm._v(" "), _c('p', {
    staticClass: "hang_box"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  }), _vm._v("  Antiques and flea markets in L’Isle-sur-la-Sorgue (see "), _c('a', {
    attrs: {
      "href": "#/OEBPS/c01_sec4#page19"
    }
  }, [_vm._v("here")]), _vm._v("), Villeneuve-lèz-Avignon (see "), _c('span', {
    attrs: {
      "href": "#/OEBPS/c07_sec7#page250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), Arles (see "), _c('span', {
    attrs: {
      "href": "#/OEBPS/c04_sec8#page136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), Carpentras (see "), _c('span', {
    attrs: {
      "href": "#/OEBPS/c01_sec10#page37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("), and others described in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_box1"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  }), _vm._v("  Antiques shops. L’Isle-sur-la-Sorgue has a dense concentration, but they’re common along roadways. One of my favorites is Galerie de la Gare in Mollégès on Route D99 near Saint-Rémy, and several along the road connecting L’Isle to Le Thor.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_box1"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  }), _vm._v("  Major antiques fairs during Easter weekend and on August 15, especially in L’Isle-sur-la-Sorgue.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_box1"
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  }), _vm._v("  Even the smallest villages host occasional "), _c('em', [_vm._v("brocantes")]), _vm._v(" and "), _c('em', [_vm._v("vide-greniers")]), _vm._v(". Watch for roadside posters announcing them or inquire at Offices de Tourisme.")]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_c('strong', [_vm._v("Other Tips")])]), _vm._v(" "), _c('p', {
    staticClass: "hang_box"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Know what you’re getting")]), _vm._v(". Antique linens are folded to present the best side. A coat of dark brown shoe polish can make a drawer look like old wood when, in fact, it was cut and fitted only a few days ago. Inspect items carefully.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_box1"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Bargaining")]), _vm._v(". It’s fine to negotiate, but always do so courteously. If you start too low or demand a specific price, the dealer would rather turn you away than make a sale. I generally begin at 25–30 percent below asking and settle for 10–20 percent, if I can get it.")]), _vm._v(" "), _c('p', {
    staticClass: "hang_box1"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/flower.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Shipping")]), _vm._v(". Established dealers work with shippers and can assist with arrangements. Know the options and prices before you seal the deal. Ask if large purchases can be exempt from VAT. Paperwork is involved, but the savings can be significant.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02464975","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01_sec5.vue
// module id = 102
// module chunks = 0